var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRealAccount = function SvgRealAccount(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 40.0013C31.0467 40.0013 40.001 31.047 40.001 20.0013C40.001 8.95557 31.0467 0.00126648 20.001 0.00126648C8.95528 0.00126648 0.000976562 8.95557 0.000976562 20.0013C0.000976562 31.047 8.95528 40.0013 20.001 40.0013Z",
    fill: "url(#paint0_radial_15_5685)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint1_linear_15_5685)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint2_radial_15_5685)",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0414 22.072V28H12.9854V10.864H20.9534C23.0974 10.864 24.7454 11.352 25.8974 12.328C27.0494 13.288 27.6254 14.672 27.6254 16.48C27.6254 17.632 27.3294 18.64 26.7374 19.504C26.1454 20.352 25.3134 20.992 24.2414 21.424L28.1774 28H23.7134L20.2574 22.072H17.0414ZM17.0414 14.056V18.88H20.4254C21.4814 18.88 22.2654 18.688 22.7774 18.304C23.2894 17.904 23.5454 17.296 23.5454 16.48C23.5454 15.664 23.2894 15.056 22.7774 14.656C22.2654 14.256 21.4814 14.056 20.4254 14.056H17.0414Z",
    fill: "#001947"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_15_5685)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5002 30C16.4789 30 27.0002 19.4787 27.0002 6.50003C27.0002 4.6177 26.7789 2.78706 26.3609 1.03271C34.2882 3.69003 40.0002 11.178 40.0002 20C40.0002 31.0457 31.0459 40 20.0002 40C12.5914 40 6.12351 35.9715 2.66748 29.9856C2.94387 29.9952 3.22147 30 3.5002 30Z",
    fill: "url(#paint3_linear_15_5685)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_15_5685",
    x: 1.33415,
    y: -0.300619,
    width: 39.9992,
    height: 41.634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_15_5685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_15_5685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15_5685",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9271 -9.90014e-05) rotate(135) scale(34.9872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_5685",
    x1: 18.3343,
    y1: -3.33334,
    x2: 0.000973962,
    y2: 23.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_15_5685",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 9.5) rotate(143.291) scale(47.3994 39.1256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15_5685",
    x1: 21.339,
    y1: 40,
    x2: 26.3304,
    y2: 11.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRealAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/real-account.536c3e40.svg";
export { ForwardRef as ReactComponent };